import React from 'react';

import { Badge as AntdBadge } from 'antd';

import styles from 'styles/styles';

const Badge = (props) => <AntdBadge {...props} style={{ backgroundColor: styles.color.primary }} />;
export default Badge;
